import { render } from "./slide10.vue?vue&type=template&id=e21523c8"
import script from "./slide10.vue?vue&type=script&lang=js"
export * from "./slide10.vue?vue&type=script&lang=js"

import "./slide10.vue?vue&type=style&index=0&id=e21523c8&lang=scss"

import exportComponent from "/Users/dima/Projects/OrangeStatic/rise-homestories/public/themes/rise-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__